<template>
  <div>
    <div
      class="flex flex-wrap cursor-pointer text-left mt-8 mb-4"
      @click="$emit('checkboxClick')"
    >
      <div class="relative">
        <transition-group name="fade">
          <BaseIcon
            v-if="value"
            key="1"
            class="absolute text-2xl"
            name="check-square"
          />
          <BaseIcon
            v-else
            key="2"
            class="absolute text-2xl"
            :name="['far', 'square']"
          />
        </transition-group>
      </div>

      <div class="ml-8">
        <slot />
      </div>
    </div>

    <BaseInputError v-if="v.$invalid && v.$error" class="w-full">
      <slot name="error">
        Es necesario leer y aceptar la Política de Protección de Datos
      </slot>
    </BaseInputError>

    <BaseInputError v-if="serverErrors[name]" class="w-full">
      {{ serverErrors[name][0] }}
    </BaseInputError>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    value: {
      type: Boolean,
    },
    name: {
      type: String,
      required: true,
    },
    v: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapState('forms', ['serverErrors']),
  },
}
</script>
